import './style.scss';
import { Description, labelColor, labelSize } from 'views/mutual/description';
import { Button, ButtonFill, ButtonSize, ButtonType } from 'views/mutual/button';
import { Toast, ToastProps } from 'views/mutual/toast';
import { useActivationCode } from './hooks';

export const ActivationCode = () => {
    const {formik, activationCodeProps, toastProps} = useActivationCode();
  return (
    <>
      <form onSubmit={formik.handleSubmit} className="loginsStyle">
        <div className="loginsStyle_inputs">
          <Description
            labelColor={labelColor.gray}
            labelSize={labelSize.medium}
            label={'アクティベーションコードを入力してください'}
          />
          <div className="loginsStyle_inputs_wrapper">
            <div className="loginsStyle_inputs_wrapper_label">アクティベーションコード</div>
            <div className="loginsStyle_inputs_wrapper_button">
              <input
                type="text"
                name="authenticationCode"
                placeholder="半角英数字で入力"
                {...activationCodeProps}
              />
            </div>
            {formik.errors.activationCode ? (
              <div className="errorRed">{formik.errors.activationCode}</div>
            ) : null}
          </div>
          <div className="loginsStyle_inputs_buttons">
            <Button
              label="認証"
              buttonFill={ButtonFill.primary}
              buttonSize={ButtonSize.medium}
              type={ButtonType.Submit}
            />
          </div>
        </div>
      </form>
      <Toast {...toastProps} />
    </>
  );
};
